import { ERecommendationsActionTypes } from '../../actions/recommendations';
import { TReduxActions } from '../../types/redux';
import { IRecommendationsState } from '../../types/redux/recommendations';

export const recommendationsInitialState: IRecommendationsState = {
  recommendations: [],
};

export function recommendationsReducer(state: IRecommendationsState, action: TReduxActions): IRecommendationsState {
  switch (action.type) {
    case ERecommendationsActionTypes.SetRecommendations:
      return {
        ...state,
        recommendations: action.payload,
      };
    default:
      return state || recommendationsInitialState;
  }
}
